export class ContextNotFoundError extends Error {
    constructor(message) {
        super(message);
        this.name = 'ContextNotFoundError';
    }
}
